import BaseHeadBanner from "../../../components/elements/BaseHeadBanner"
import BasePage from "../../../components/layout/BasePage"
import { ReactComponent as PLUSCIRCLE } from "../../../assets/PlusInCircleIcon.svg"
import BaseButtonRow from "../../../components/elements/BaseButtonRow"
import BaseGrowBody from "../../../components/elements/BaseGrowBody"
import AllTasksTable from "../components/AllTasksTable"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { getPaginatedData } from "../../api/apiCalls"
import { useContext, useEffect, useMemo, useState } from "react"
import AddTaskModal from "../components/AddTaskModal"
import { ModalContext } from "../../../components/contexts/ModalContext"
import { getDataFromSessionStorage, useDelayWhenSearchWithPagination } from "../../../services/functions"
import { useDeleteTaskTemplateMutation, useUpdateTaskTemplateStateMutation } from "../api/services"
import BaseInputSearch from "../../../components/elements/BaseInputSearch"
import { CostCenterType } from "../../Mitarbeiter/types/Types"
import BaseSelection from "../../../components/elements/BaseSelection"
import ErrorPage from "../../404/ErrorPage"
import Loading from "../../../components/common/Loading"
import { Pagination } from "antd"
import BaseButton from "../../../components/elements/BaseButton"
import { ReactComponent as TASKS } from "../../../assets/Task.svg"
import { useNavigate } from "react-router-dom"
import { LocalStorageKeys, GeneralQueryKeys } from "../../../api/constants"
import { getCostCenterNames } from "../../Dashboard/api/apiCalls"
import { P } from "../../../auth/permissions"
import { Authorized } from "../../../components/authentication/Authorized"

export default function TaskTemplateOverviewPage() {
    // GET all costcenter
    const {
        error: costcenterError,
        data: costcenterData,
        isLoading: costcenterisLoading,
    } = useQuery({
        queryKey: [GeneralQueryKeys.COSTCENTER_NAMES],
        queryFn: getCostCenterNames,
    })
    const [selectedCostCenter, setselectedCostCenter] = useState<CostCenterType>(getDataFromSessionStorage(LocalStorageKeys.TASK_TEMPLATE_FILTER + "costcenter"))
    useEffect(() => costcenterData && setselectedCostCenter(costcenterData[0]), [costcenterData])

    // GET Task Templates
    const [page, setpage] = useState<number>(getDataFromSessionStorage(LocalStorageKeys.TASK_TEMPLATE_FILTER + "page") ?? 1)
    const handlePageChange = (page: number) => {
        sessionStorage.setItem(LocalStorageKeys.TASK_TEMPLATE_FILTER + "page", JSON.stringify(page))
        setpage(page)
    }
    const [searchTermTaskTemplates, setsearchTermTaskTemplates] = useState(getDataFromSessionStorage(LocalStorageKeys.TASK_TEMPLATE_FILTER + "searchTerm"))
    const searchParamsTaskTemplates = useDelayWhenSearchWithPagination(searchTermTaskTemplates, LocalStorageKeys.TASK_TEMPLATE_FILTER + "searchTerm")
    const queryKeyTaskTemplates = GeneralQueryKeys.TASK_TEMPLATE + searchParamsTaskTemplates + selectedCostCenter?._id
    const {
        error: allTaskTemplatesError,
        isLoading: allTaskTemplatesIsLoading,
        data: allTaskTemplatesData,
    } = useQuery({
        queryKey: [queryKeyTaskTemplates],
        queryFn: () =>
            getPaginatedData({
                pageType: "task-template",
                page: page,
                limit: 20,
                search: searchParamsTaskTemplates,
                costCenterId: selectedCostCenter?._id ?? "",
            }),
    })
    const displayedTaskTemplates = useMemo(() => allTaskTemplatesData?.docs, [allTaskTemplatesData?.docs])

    // FRONTEND LOGIC
    const modalCon = useContext(ModalContext)
    const queryClient = useQueryClient()

    // DELETE Task template
    const { mutate: deleteTaskTemplate } = useDeleteTaskTemplateMutation(queryClient, queryKeyTaskTemplates)

    // UPDATE Task template state
    const { mutate: updateTaskTemplateState } = useUpdateTaskTemplateStateMutation(queryClient, queryKeyTaskTemplates)

    const navigate = useNavigate()

    return (
        <>
            {(costcenterError || allTaskTemplatesError) && <ErrorPage />}
            {(costcenterisLoading || allTaskTemplatesIsLoading) && <Loading />}
            {costcenterData && allTaskTemplatesData && (
                <BasePage>
                    <BaseHeadBanner
                        title={"Wiederkehrende Aufgaben"}
                        button={<PLUSCIRCLE onClick={() => modalCon?.trigger(0)} className="cursor-pointer w-8 h-8" />}
                    />
                    <BaseButtonRow>
                        <div className="flex gap-2 items-center">
                            <BaseInputSearch
                                placeholder={"Objekt suchen..."}
                                hidden="hidden lg:flex"
                                searchTerm={searchTermTaskTemplates}
                                setsearchTerm={setsearchTermTaskTemplates}
                            />
                            <Authorized allOf={[P.niederlassungen_read]}>
                                <BaseSelection
                                    bgwhite
                                    label={""}
                                    classProps="!w-64"
                                    disabled={costcenterData.length === 1}
                                    value={selectedCostCenter?.name}
                                    data={costcenterData?.map((item: { name: any }) => item.name)}
                                    setId={(e: string) => setselectedCostCenter(costcenterData?.find((item: { name: string }) => item.name === e))}
                                    placeholder={""}
                                />
                            </Authorized>
                        </div>
                        <BaseButton
                            hideLabelOnMobile="sm"
                            label={"Aufgaben"}
                            func={() => navigate("/aufgaben")}
                            icon={<TASKS className="w-6 h-6" />}
                        />
                    </BaseButtonRow>
                    <BaseGrowBody classProps=" overflow-x-hidden my-4">
                        <AllTasksTable taskTemplates={displayedTaskTemplates} addOrPause={updateTaskTemplateState} deleteTask={deleteTaskTemplate} />
                    </BaseGrowBody>
                    {/* PAGINATION */}
                    <div className="flex justify-center w-full p-4">
                        <Pagination
                            pageSize={20}
                            defaultCurrent={1}
                            current={page}
                            onChange={handlePageChange}
                            total={allTaskTemplatesData.totalDocs}
                            showSizeChanger={false}
                        />
                    </div>
                    <AddTaskModal
                        modalId={0}
                        queryKey={queryKeyTaskTemplates}
                        type="taskTemplate"
                    />
                </BasePage>
            )}
        </>
    )
}
